// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ql-5";
export var filledCircle = "_ql-4";
export var historyEntry = "_ql-3";
export var messageSideLeft = "_ql-1";
export var messageSideRight = "_ql-2";
export var orderTrackingCarouselWrapper = "_ql-6";
export var orderTrackingInfoContainer = "_ql-0";